/* eslint-disable no-underscore-dangle */
import { apiClient, handleResponse } from './axios';

const formatTeacher = (teachers) => {
  try {
    const formatedTeachers = [];
    for (let i = 0; i < teachers.length; i += 1) {
      formatedTeachers.push({
        label: `${teachers[i].name} ${teachers[i].firstname}`,
        value: teachers[i].name,
        id: teachers[i]._id,
      });
    }
    return formatedTeachers;
  } catch (error) {
    return error.response;
  }
};

async function getAll() {
  try {
    const response = await apiClient.get('/teacher');
    const teachers = await handleResponse(response);
    return formatTeacher(teachers);
  } catch (error) {
    return error.response;
  }
}

async function getTeachers() {
  try {
    const response = await apiClient.get('/teacher');
    const teachers = await handleResponse(response);
    return teachers;
  } catch (error) {
    return error.response;
  }
}

async function getTeacherById(id) {
  try {
    const response = await apiClient.get(`/teacher/${id}`);
    const teachers = await handleResponse(response);
    return teachers;
  } catch (error) {
    return error.response;
  }
}

async function deleteTeacher(userId) {
  try {
    const response = await apiClient
      .delete(`/teacher/${userId}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function createTeacher(body) {
  try {
    const response = await apiClient.post('/teacher', body);
    const teacher = await handleResponse(response);
    return teacher;
  } catch (error) {
    return error.response;
  }
}

async function updateTeacher(id, body) {
  try {
    const response = await apiClient
      .put(`/teacher/${id}`, body);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function login(email, password, rememberMe) {
  const body = JSON.stringify({ email, password, rememberMe });
  try {
    const user = await apiClient
      .post('/teacher/login', body);
    return user;
  } catch (error) {
    return error.response;
  }
}

async function getTeacherByGroup(id) {
  try {
    const response = await apiClient
      .get(`/teacher/group/${id}`);
    const data = await handleResponse(response);
    return formatTeacher(data);
  } catch (error) {
    return error.response;
  }
}

const teacherServices = {
  getAll,
  getTeachers,
  getTeacherById,
  login,
  deleteTeacher,
  createTeacher,
  updateTeacher,
  getTeacherByGroup,
};

export default teacherServices;
